export { preloadPostOfficeConfluenceHomeBanner } from '../src/preloadConfluenceHomeBanner';
